// Helper functions for working with dates and activities
import { format, formatDistance } from 'date-fns';

export interface ActivityUpdate {
  type: string;
  message: string;
  timestamp: Date;
}

export const formatTimestamp = (timestamp: string | Date): string => {
  if (!timestamp) return '';
  const date = typeof timestamp === 'string' ? new Date(timestamp) : timestamp;
  return format(date, 'h:mm a');
};

export const getTimeSince = (timestamp: string | Date): string => {
  if (!timestamp) return '';
  const date = typeof timestamp === 'string' ? new Date(timestamp) : timestamp;
  return formatDistance(date, new Date(), { addSuffix: true });
};

export const getActivityIcon = (type: string): string => {
  switch (type) {
    case 'roleChange':
      return '👤'; // User icon
    case 'userRegistration':
      return '➕'; // Plus icon
    case 'system':
      return '🖥️'; // Computer icon
    default:
      return '📝'; // Default activity icon
  }
};
